import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, findIndex, forEach, clone, isEmpty } from 'lodash';
import {
    getOtherUsersTeam
} from './../../actions/LeagueActions';
import OutsideNotifier from '../../OutsideNotifier';
import { withRouter } from 'react-router-dom';
import config from './../../config';
import common from './../../common';
import AdBottom from '../AdBottom';
import trackEventsObj from '../../constants/new-pageTrackEvents';

import PlayerCard from './../playerCard';
import { setTotalScore } from './../../actions/AppActions';
import {
    triggerHandlePlayerCard,
    playersFetchData, triggerMixFetchData, triggerLiveScoreFetchData
} from './../../actions/FormationActions';
import { getFixtureStatus, getLivePlayersData, groupBySkill, getPlayerInfoIfFound, findMatchEndMode } from './../../helper';
import { gamerCardFetchData, postSubscribe, editorialCardFetchData, eosFetchData } from './../../actions/HomeActions';
import { getMatchTimeObj } from '../../helper-common';



class ViewOthersTeam extends Component {

    constructor(props) {
        super(props);

    }

    timeout_mix = 0;
    timeout_local = 0;
    timeout_live = 0;

    componentWillMount() {
        this.initialize();
        common.pageViewTracking("", trackEventsObj["viewOthersTeam"]);
        let self = this;

        self.setInitialState();

        this.hitMixAPi();

    }

    triggerPrev = () => {
        this.props.history.goBack();
    };
    setInitialState = () => {
        this.setState({
            userSpecificFixtures: [],
            isDDOpen: false,
            currentActiveFixture: 0,
            OppCurrTeamGDID: 0
        });
        this.GUID = null;
        this.UserId = null;
        this.UserTeamId = null;
    };
    onDDTap = () => {
        this.setState(prevState => ({
            isDDOpen: !prevState.isDDOpen,
        }));
    };
    onPreviousTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: --currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onNextTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: ++currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onSelect = (selectedFixture) => {
        let { currentActiveFixture } = this.state;
        let newState = { isDDOpen: !this.state.isDDOpen };
        if (currentActiveFixture !== selectedFixture) {
            newState.currentActiveFixture = selectedFixture;
            this.getRespectiveData(selectedFixture);
        }
        this.setState(newState);
    };
    getRespectiveData = (currentActiveFixture) => {
        const { userSpecificFixtures } = this.state;
        const GDID = userSpecificFixtures[currentActiveFixture];
        this.getTeam(GDID);
    };
    getTeam = (GDID) => {
        common.showLoader();
        this.props.getOtherUsersTeam(this.GUID, GDID, this.UserId, this.UserTeamId).then(() => {
            const { othersTeam } = this.props;
            const { Players, OppPlayedGDs, OVPoints, OVRank, TeamName, BadgeId, GDPoints, OppCurrTeamGDID, UserName } = othersTeam;
            this.setState({
                OppCurrTeamGDID: OppCurrTeamGDID
            })
            let playersPromise = {};
            if (OppCurrTeamGDID) {
                playersPromise = this.props.fetchPlayers(OppCurrTeamGDID);
                Promise.all([playersPromise]).then((PlayersData) => {
                    let playerList = PlayersData[0].payload.Data.Value.playerList;

                    let updatedPlayerList = []
                    Players.forEach((plyr) => {
                        let plyrObj = playerList.find((p) => {

                            return plyr.Id == p.Id;
                        })
                        if (plyrObj) {
                            updatedPlayerList.push(Object.assign(plyrObj, plyr));
                        }

                    })

                    const currentActiveFixture = findIndex(OppPlayedGDs, (el) => el === OppCurrTeamGDID);
                    this.setState({
                        Players: updatedPlayerList,
                        userSpecificFixtures: OppPlayedGDs,
                        OVPoints,
                        OVRank,
                        TeamName,
                        BadgeId,
                        GDPoints,
                        currentActiveFixture,
                        UserName,
                    });
                    common.hideLoader();
                }).catch(reason => {
                    common.hideLoader();
                });
            }



        }).catch(reason => {
            common.hideLoader();
        });
    };

    componentDidMount() {
        const { GUID, GDID, UserId, UserTeamId } = this.props.match.params;
        this.GUID = GUID;
        this.UserId = UserId;
        this.UserTeamId = UserTeamId;
        this.getTeam(GDID);
    }

    showPopUp(player) {

        this.props.triggerHandlePlayerCard(true, player);
    }

    //api for live scoring and live score display
    initialize = () => {
        let self = this;
        this.clearAllTimeout();


        this.props.fetchGamerCard().then(() => {
            let data = self.props.homeData ? self.props.homeData.Data.Value : null;
            const { gcStats } = data;
            self.props.setTotalScore(gcStats['TrPoints']);
            const userFixtureStatus = getFixtureStatus(gcStats);
            this.setState({ userFixtureStatus })
            if (userFixtureStatus === config.fixtureStatus.isLock) {
                self.callLiveAPI();
            } else if (userFixtureStatus !== config.fixtureStatus.isFinished) {
                self.hitMixAPi();
            }



        }).catch(reason => {
        });
    }

    clearAllTimeout = () => {
        clearTimeout(this.timeout_mix);
        clearTimeout(this.timeout_local);
        clearTimeout(this.timeout_live);
    };

    callLiveAPI = () => {
        this.props.triggerLiveScoreFetchData().then(() => {
            this.timeout_live = setTimeout(() => {
                this.hitMixAPi();
                this.callLiveAPI();
            }, 1000 * config.MIXED_API_INTERVAL_DURATION);
        });
    };

    startInterval = (Deadline, OffSet, MixApiFixtureStatus) => {
        if (MixApiFixtureStatus !== config.fixtureStatus.isLock) {
            common.getDiffWithCurrentTimeInMinutes(Deadline, OffSet, (diffInMins) => {
                if (diffInMins > config.TIME_DIFF_TO_CONSIDER) {
                    if (diffInMins < config.MIXED_API_INTERVAL_START_TIME) {
                        this.timeout_mix = setTimeout(this.hitMixAPi, 1000 * config.MIXED_API_INTERVAL_DURATION);
                    } else {
                        this.timeout_local = setTimeout(() => {
                            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
                        }, 1000 * config.MIXED_API_BEFORE_INTERVAL_DURATION);
                    }
                }
            });
        }
    };

    hitMixAPi = () => {
        let self = this;
        self.props.triggerMixFetchData().then(() => {
            const mixedResponse = this.props.mixResponse;
            let { Deadline, Fixture } = mixedResponse;
            const { OffSet } = this.props.constraints;
            const MixApiFixtureStatus = getFixtureStatus(Fixture || {});
            if (Fixture) {
                let data = this.props.homeData.Data.Value;
                const { gcStats } = data;
                const gamedayId = gcStats['GameDay'];
                if (+gamedayId === +Fixture['GDID']) {
                    const userFixtureStatus = getFixtureStatus(gcStats);
                    if (userFixtureStatus !== MixApiFixtureStatus) {
                        common.updateBusters('/bust-after-status-change');
                        return self.initialize();
                    }
                }
            }
            self.startInterval(Deadline, OffSet, MixApiFixtureStatus);
        });
    };

    componentWillUnmount() {
        this.clearAllTimeout();
    }

    getLivePlayersData(teamData, liveData) {
        let total = 0;
        const orderToScan = ['4', '3', '2', '1', '0'];
        forEach(orderToScan, (skillIndex) => {
            forEach(teamData[skillIndex], (player) => {
                let { stats, points } = getPlayerInfoIfFound(player.Id, liveData);
                points = clone(points);
                let pointsToConsider = 0;
                if (!isEmpty(points)) {
                    points.TPoints = +(points.TPoints || 0);
                    if (+player.BenchPosition === 0) {
                        if (+player.IsCaptain === 1) {
                            points.TPoints *= 2;
                        }
                        pointsToConsider = points.TPoints;
                    }
                }
                player.stats = stats;
                player.points = points;
                total += pointsToConsider;
            });
        });
        teamData.totalLivePoints = total;
        return teamData;
    }

    createFixtureGroups = () => {

        const mixedResponse = this.props.mixResponse;
        let { Fixture } = mixedResponse;

        if (Fixture) {
            // const userSpecificFixtures = getFixturesToPrintForMatches(fixtures);
            // const defaultIndex = findIndex(userSpecificFixtures, { selected: true });
            // const selectedGameDay = userSpecificFixtures[defaultIndex];
            const gameday = Fixture;
            const { trans, constraints } = this.props;
            let obj = {
                group: {},
                lockTime: ''
            };
            for (let i = 0; i < gameday.Match.length; i++) {
                let match = gameday.Match[i];
                let MDNo = match.MDNo;
                if (!obj.group[MDNo]) {
                    // match.DateTime = '2018-08-08 20:45';
                    obj.group[MDNo] = {
                        date: getMatchTimeObj(match.DateTime, trans, constraints.OffSet),
                        subsWindow: {
                            isAvailable: false
                        },
                        matches: [],
                        livesetMatches: Fixture.MatchDay == MDNo && Fixture.MdIsCurr == 1 ? true : false,
                    };
                    if (match.TeamSc) {
                        obj.group[MDNo]["subsWindow"]["isAvailable"] = (match.TeamSc === "UT_SUB");
                        obj.group[MDNo]["subsWindow"]["TeamScStartDate"] = match.TeamScStartDate;
                        obj.group[MDNo]["subsWindow"]["TeamScEndDate"] = match.TeamScEndDate;
                        if (match.TeamSc === "UT_TRF") {
                            obj.lockTime = match.TeamScEndDate;
                        }
                    }
                }
                obj.group[MDNo].matches.push(match);
            }

            var matchLength = "";
            for (var property in obj.group) {
                if (obj.group.hasOwnProperty(property)) {
                    // Do things here
                    if (obj.group[property].livesetMatches) {
                        matchLength = obj.group[property].matches.length
                    }
                }
            }

            return matchLength;
        }
    };

    render() {
        const teamData = this.props.othersTeam;
        const { trans } = this.props;
        // let teamPlayers = groupBySkill(teamData.Players)
        // const liveData = this.getLivePlayersData(teamPlayers, this.props.liveScore);



        if (Object.keys(teamData).length) {
            const { Players, userSpecificFixtures, OVPoints, OVRank, TeamName, BadgeId, GDPoints, currentActiveFixture, UserName, OppCurrTeamGDID } = this.state;
            let imgSrc = config.playerImgBase + `badges/${BadgeId}.png`;
            let teamDataNew = {};
            ['4', '3', '2', '1', '0'].forEach((skill) => {
                let filterHandler = (player) => {
                    return player['BenchPosition'] === 0 && player['Skill'] === +skill;
                };
                if (skill === '0') {
                    filterHandler = (player) => {
                        return player['BenchPosition'] > 0;
                    }
                }
                teamDataNew[skill] = filter(Players, filterHandler);
            });

            const liveData = this.getLivePlayersData(teamDataNew, this.props.liveScore);
            let fixGroup = this.createFixtureGroups();
            let matchEndMode = findMatchEndMode(this.props.liveScore, fixGroup)

            const matchDayTrans = trans['matchday'];
            const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
            // const selectedLabel = matchDayTrans + ' ' + selectedMatchDay;
            const selectedLabel = trans['rd' + selectedMatchDay];
            const isFirst = currentActiveFixture === 0;
            const isLast = currentActiveFixture === (userSpecificFixtures.length - 1);
            // let data = this.props.homeData ? this.props.homeData.Data.Value : null;
            let isCurrentMatch = false
            if (selectedMatchDay == userSpecificFixtures[userSpecificFixtures.length - 1]) {
                isCurrentMatch = true
            }

            let isCurrentMatchLive = (isCurrentMatch && this.state.userFixtureStatus && this.state.userFixtureStatus === config.fixtureStatus.isLock)

            const prevBtnClasses = common.makeClasses({
                'si-arrows': true,
                'icon-ucl-arrow_right': true,
                'si-disabled': isFirst
            });
            const nextBtnClasses = common.makeClasses({
                'si-arrows': true,
                'icon-ucl-arrow_left': true,
                'si-disabled': isLast
            });
            const keysToDisplay = ['4', '3', '2', '1'];
            let boosterMarkup = null;
            const teamToDisplay = keysToDisplay.map((keyIndex) => {
                const posArray = teamDataNew[keyIndex];
                const numOfPlayers = posArray.length;
                const numOfPlayersInWords = common.numToWord(numOfPlayers);
                const classN = 'si-row-' + numOfPlayersInWords;
                const players = posArray.map(player => {
                    const captainClass = +player.IsCaptain ? 'si-captain-icon' : '';
                    const teamImg = config.playerImgBase + `player-jersey/${(player.Skill === 1) ? 'GK/' : ''}${player['TeamId']}.png`;
                    // const VsCCode = player
                    //     && player.UpComingMatchesList
                    //     && player.UpComingMatchesList[0]
                    //     && player.UpComingMatchesList[0].VsCCode;
                    // const TLoc = player
                    //     && player.UpComingMatchesList
                    //     && player.UpComingMatchesList[0]
                    //     && player.UpComingMatchesList[0].TLoc;
                    const UpComingMatchesList = player && player['UpComingMatchesList'] ? player['UpComingMatchesList'] : [];
                    let vsObj = {};
                    let vsTeam = '';
                    if (UpComingMatchesList.length > 0) {
                        vsObj = UpComingMatchesList[0];
                    }
                    let homeAwayIndctr = "";
                    if (vsObj.hasOwnProperty('TLoc') && vsObj['TLoc'] != "" && vsObj['TLoc'] != null && vsObj['TLoc'] != undefined && vsObj['TLoc'] != "undefined") {
                        homeAwayIndctr = "(" + vsObj['TLoc'] + ")"
                    }
                    console.log("vsObj.hasOwnProperty('VsCCode')", vsObj['VsCCode'], player['DisplayName']);
                    if (vsObj.hasOwnProperty('VsCCode')) {
                        vsTeam = vsObj['VsCCode'];
                    }

                    const fixtures = this.props.trans.vs_short + " " + vsTeam + " " + (homeAwayIndctr ? " " + homeAwayIndctr + " " : "");

                    // const fixtures = TLoc ? VsCCode + " (" + TLoc + ")" : "-";
                    let PlayerInLive = liveData[player.Skill].find((p) => { return p.Id == player.Id })
                    let isPlaying = (PlayerInLive && !isEmpty(PlayerInLive.points))
                    let disableClass = ""
                    if (isCurrentMatchLive) {
                        disableClass = "si-disabled-plyr"
                        if (isPlaying) {
                            disableClass = ""
                        }
                    }

                    return <div className={ "si-plyr-wrap si-selected " + disableClass } key={ player.Id }>
                        <div className="si-data-wrap" onClick={ () => this.showPopUp(player) }>
                            <span className={ "si-img-wrap " + captainClass }
                                style={ { backgroundImage: "url(" + teamImg + ")" } } />
                            <div className="si-plyr-pos">{ this.props.trans['short' + player.skill] }</div>
                            <div className="si-plyr-details ">
                                <span className="si-plyr-name">{ player['DisplayName'] }</span>
                                {
                                    (isCurrentMatchLive && PlayerInLive && !isEmpty(PlayerInLive.points))
                                        ?
                                        <span className="si-plyr-val si-live-pts">{ (PlayerInLive.points ? PlayerInLive.points.TPoints : 0) + " " + trans['labelPts'] }</span>
                                        :
                                        <span className={ player.IsPlayed == 0 && player.OverallPoints === "" ? "si-plyr-val" : "si-plyr-val si-final-pts" }>{ player.IsPlayed == 0 && player.OverallPoints === "" ? fixtures : (player['OverallPoints'] || '0') + " " + trans['labelPts'] } </span>
                                }

                            </div>
                        </div>
                    </div>
                });






                return <div className={ "si-team-row si-flexBox " + classN } key={ keyIndex }>{ players }</div>
            });
            let cssClassForWildCard = "";
            let textToShowWildActive = "";
            if (teamData.IsWildCardTaken == 0) {
                cssClassForWildCard = '';
            } else {
                if (teamData.UserWildCardGameday == OppCurrTeamGDID) {
                    cssClassForWildCard = 'si-selected';
                    textToShowWildActive = trans.active ? trans.active : "active";
                } else if (parseInt(teamData.UserWildCardGameday) > parseInt(OppCurrTeamGDID)) {
                    cssClassForWildCard = ''
                } else {
                    cssClassForWildCard = 'si-disabled'
                }
            }


            let cssClassForlimitLess = "";
            let textToShowLimitActive = "";
            if (teamData.IsBoosterOneTaken == 0) {
                cssClassForlimitLess = '';
            } else {
                if (teamData.BoosterOneGDID == OppCurrTeamGDID) {
                    cssClassForlimitLess = 'si-selected';
                    textToShowLimitActive = trans.active ? trans.active : "active";
                } else if (parseInt(teamData.BoosterOneGDID) > parseInt(OppCurrTeamGDID)) {
                    cssClassForlimitLess = ''
                } else {
                    cssClassForlimitLess = 'si-disabled'
                }
            }

            boosterMarkup = <div className="si-booster-used" >
                <div className="si-booster-wrap">
                    <div className={ "si-booster " + cssClassForWildCard }>
                        <i className="icon-ucl-wildcard" />
                        <span> {
                            trans.wildcard +
                            " " + textToShowWildActive
                        } </span>
                    </div>
                    <div className={ "si-booster " + cssClassForlimitLess } >
                        < i className="icon-ucl-limitless" />
                        <span> {
                            trans.limitless +
                            " " + textToShowLimitActive
                        } </span>
                    </div>
                </div>


            </div>


            const benchArray = teamDataNew['0'];
            const numOfPlayers = benchArray.length;
            const numOfPlayersInWords = common.numToWord(numOfPlayers);
            const classN = 'si-row-' + numOfPlayersInWords;
            let players = benchArray.map((player, index) => {
                const teamImg = config.playerImgBase + `player-jersey/${(player.Skill === 1) ? 'GK/' : ''}${player['TeamId']}.png`;
                // const VsCCode = player
                //     && player.UpComingMatchesList
                //     && player.UpComingMatchesList[0]
                //     && player.UpComingMatchesList[0].VsCCode;
                // const TLoc = player
                //     && player.UpComingMatchesList
                //     && player.UpComingMatchesList[0]
                //     && player.UpComingMatchesList[0].TLoc;
                // const fixtures = TLoc ? VsCCode + " (" + TLoc + ")" : "-";
                const UpComingMatchesList = player && player['UpComingMatchesList'] ? player['UpComingMatchesList'] : [];
                let vsObj = {};
                let vsTeam = '';
                if (UpComingMatchesList.length > 0) {
                    vsObj = UpComingMatchesList[0];
                }
                let homeAwayIndctr = "";
                if (vsObj.hasOwnProperty('TLoc') && vsObj['TLoc'] != "" && vsObj['TLoc'] != null && vsObj['TLoc'] != undefined && vsObj['TLoc'] != "undefined") {
                    homeAwayIndctr = "(" + vsObj['TLoc'] + ")"
                }
                if (vsObj.hasOwnProperty('VsCCode')) {
                    vsTeam = vsObj['VsCCode'];
                }

                const fixtures = this.props.trans.vs_short + " " + vsTeam + " " + (homeAwayIndctr ? " " + homeAwayIndctr + " " : "");



                let PlayerInLive = liveData[0].find((p) => { return p.Id == player.Id })
                let isPlaying = (PlayerInLive && !isEmpty(PlayerInLive.points))
                let disableClass = ""
                if (isCurrentMatchLive) {
                    disableClass = "si-disabled-plyr"
                    if (isPlaying) {
                        disableClass = ""
                    }
                }
                return <div className={ "si-plyr-wrap si-selected " + disableClass } key={ player.Id }>
                    <div className="si-data-wrap" onClick={ () => this.showPopUp(player) }>
                        <span className="si-img-wrap" style={ { backgroundImage: "url(" + teamImg + ")" } } />
                        <div className="si-plyr-pos">{ this.props.trans['short' + player.skill] }</div>
                        <div className="si-plyr-details ">
                            <span className="si-plyr-name">{ player['DisplayName'] }</span>
                            {/* <span
                                className="si-plyr-val si-final-pts">{ player['OverallPoints'] || '-' } { trans['labelPts'] }</span> */}
                            {
                                (isCurrentMatchLive && PlayerInLive && !isEmpty(PlayerInLive.points))
                                    ?
                                    <span className="si-plyr-val si-invalid-pts">{ (PlayerInLive.points ? PlayerInLive.points.TPoints : 0) + " " + trans['labelPts'] }</span>
                                    :
                                    <span className={ player.IsPlayed == 0 && player.OverallPoints === "" ? "si-plyr-val" : "si-plyr-val si-invalid-pts" }>{ player.IsPlayed == 0 && player.OverallPoints === "" ? fixtures : (player['OverallPoints'] || '0') + " " + trans['labelPts'] } </span>
                            }
                        </div>
                    </div>
                </div>
            });
            const subView = <div className={ "si-team-row si-flexBox " + classN }>{ players }</div>;
            return <div className="si-main-component si-manage-team si-no-anim si-centered-bg">
                <div className="si-container si-others-league-info">
                    <div className="si-top-section">
                        <div className="si-top-wrap">
                            <div className="si-heading-wrap si-flexBox">
                                <div className="si-back-btn si-cols">
                                    <i className="icon-ucl-back_arrow" onClick={ () => this.triggerPrev() } />
                                </div>
                                <div className="si-title">
                                    {/* <div className="si-badge-wrap">
                                        <div className="si-badge-img">
                                            <img src={ imgSrc } alt={ "" } />
                                        </div>
                                    </div> */}
                                    <span>{ TeamName }</span>
                                    <div className="si-country-name-web">({ UserName })</div>
                                </div>
                                <div className="si-score-info">
                                    <div className="si-score-block">
                                        <div className="si-info-txt">{ trans['overall'] }</div>
                                        <div className="si-score-wrap">
                                            <span className="si-score-num">{ OVPoints }</span>
                                            <span className="si-score-txt">{ trans['labelPts'] }</span>
                                        </div>
                                    </div>
                                    <div className="si-score-block">
                                        <div className="si-info-txt">{ trans['rank'] }</div>
                                        <div className="si-score-wrap">
                                            <span className="si-score-num">{ OVRank }</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="si-country-name">({ UserName })</div>
                        </div>
                        <div className="si-bottom-wrap">
                            <div className="si-score-info">
                                <div className="si-score-block">
                                    <div className="si-info-txt">{ trans['rd'] }</div>
                                    <div className="si-score-wrap">
                                        <span className="si-score-num">{ GDPoints }</span>
                                        <span className="si-score-txt">pts</span>
                                    </div>
                                </div>
                                <div className="si-score-block">
                                    <div className="si-info-txt">{ trans['overall'] }</div>
                                    <div className="si-score-wrap">
                                        <span className="si-score-num">{ OVPoints }</span>
                                        <span className="si-score-txt">{ trans['labelPts'] }</span>
                                    </div>
                                </div>
                                <div className="si-score-block">
                                    <div className="si-info-txt">{ trans['rank'] }</div>
                                    <div className="si-score-wrap">
                                        <span className="si-score-num">{ OVRank }</span>
                                    </div>
                                </div>
                            </div>
                            <div className="si-selectbox">
                                <div className="si-dropdown-btn">
                                    <i className={ prevBtnClasses } onClick={ () => this.onPreviousTap() } />
                                    <span onClick={ () => this.onDDTap() }>{ selectedLabel }</span>
                                    <i className={ nextBtnClasses } onClick={ () => this.onNextTap() } />
                                </div>
                                { this.state.isDDOpen ? <OutsideNotifier handler={ () => this.onDDTap() }>
                                    <ul className="si-dropdown-options">
                                        { userSpecificFixtures.map((el, index) => {
                                            // const selectedLabel = matchDayTrans + ' ' + el;
                                            const selectedLabel = trans['rd' + el];
                                            const isSelected = currentActiveFixture === index ? 'si-selected' : '';
                                            return <li key={ index } className={ isSelected }
                                                onClick={ () => this.onSelect(index) }>
                                                <span>{ selectedLabel }</span></li>
                                        }) }
                                    </ul>
                                </OutsideNotifier> : null }
                            </div>
                            <div className={ "si-md-info " + ((isCurrentMatchLive && !matchEndMode) ? "si-live-info" : "") }>
                                {
                                    (isCurrentMatchLive)
                                        ?
                                        matchEndMode
                                            ?
                                            <div className="si-pts-info si-flexBox">
                                                <div className="si-md-pts">
                                                    <span className="si-md-num">{ liveData.totalLivePoints }</span>
                                                    <div className="si-md-txt">
                                                        <div>{ trans['Round_Pts'] }</div>
                                                    </div>
                                                </div>

                                                <div className="si-pts-loader">
                                                    <div className="si-loader-wrap">
                                                        <div className="si-loader">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <div className="si-pts-loader-txt">{ trans.calcInProg || "Calculation in progress" }</div>
                                                </div>
                                            </div>
                                            :
                                            <div className="si-pts-info si-flexBox">
                                                <div className="si-md-pts">
                                                    <span className="si-md-num">{ liveData.totalLivePoints }</span>
                                                    <div className="si-md-txt">
                                                        <div className="si-live-anim">{ trans.live }<span /></div>
                                                        <div>{ trans.points }</div>
                                                    </div>
                                                </div>
                                            </div>

                                        :
                                        <div className="si-pts-info si-flexBox">
                                            <div className="si-md-pts">
                                                <span className="si-md-num">{ GDPoints }</span>
                                                <div className="si-md-txt">
                                                    <div>{ trans['Round_Pts'] }</div>
                                                </div>
                                            </div>
                                        </div>
                                }

                                { boosterMarkup }

                            </div>
                        </div>
                    </div>
                    <div className="si-wrap si-flexBox">
                        <div className="si-pitch-view-wrap ">
                            <div className="si-container si-pitch-sections">

                                { teamToDisplay }

                            </div>
                            <div className="si-subs-wrap">
                                <div className="si-container">
                                    { subView }
                                </div>
                            </div>

                            <div className="si-btn-wrp si-subs-btn">
                                { boosterMarkup }
                            </div>

                        </div>
                    </div>
                    { this.props.isPlayerCardVisible && !this.props.overview ? <PlayerCard friendsTeamData={ teamData.Players } OppCurrTeamGDID={ this.state.OppCurrTeamGDID } /> : null }
                    <AdBottom />
                    <div className="si-bottom-bg"></div>
                    {/* <div className="si-no-landscape"></div> */ }
                </div>
            </div>
        } else {
            return null;
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getOtherUsersTeam: (GUID, GamedayId, UserId, UserTeamId) => dispatch(getOtherUsersTeam(GUID, GamedayId, UserId, UserTeamId)),
        triggerHandlePlayerCard: (isPlayerCardVisible, playerObj) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, playerObj)),
        fetchPlayers: (gamedayId) => dispatch(playersFetchData(gamedayId)),
        triggerMixFetchData: () => dispatch(triggerMixFetchData()),
        triggerLiveScoreFetchData: () => dispatch(triggerLiveScoreFetchData()),
        fetchGamerCard: () => dispatch(gamerCardFetchData()),
        fetchEos: () => dispatch(eosFetchData()),
        setTotalScore: (score) => dispatch(setTotalScore(score)),
    };
};
const mapStateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        othersTeam: state.leaguesData.othersTeam,
        isPlayerCardVisible: state.formationData.isPlayerCardVisible,
        homeData: state.homeData.gamerCardData,
        mixResponse: state.formationData.mixResponse,
        liveScore: state.formationData.liveScore.response,
        overview: state.formationData.overview,
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewOthersTeam));


// WEBPACK FOOTER //
// ./src/components/manage-team/View-Other-Team.js